module.exports = __webpack_public_path__ + "img/social-links-bg.0c3faff.jpg";